import React, { useContext, useEffect, useState } from "react";
import TitlePage from "../../../../components/TitlePage";
import { Row, Col, Button, Form, InputGroup} from "react-bootstrap";
import ConsultaGrupoProduto from '../../../../../lib/json/consultas/GrupoProduto.json'
import ResponsiveDataTable from "../../../../components/DataTable";
import LoadingSpinner from "../../../../components/LoadinSpinner";
import { useNavigate } from "react-router-dom";
import { usePopUp } from "../../../../components/BootBox";
import { ConsultaTotvsEmpresa } from "../../../../../backend/ConsultaTotvsEmpresa";

function ListaGrupoProduto(){
    const navigate = useNavigate();
    const { DisparaBootBox, FechaBootBox  } = usePopUp();
    const columns = [
        {
            Header: 'Grupo de Produto',
            accessor: 'BM_GRUPO',
        },
        {
            Header: 'Descrição',
            accessor: 'BM_DESC',
        },
        {
            Header: 'Comprador',
            accessor: 'BM_XCOMDEF',
        },
        {
            Header: 'Nome Comprador',
            accessor: 'Y1_NOME',
        }
    ];
    
    var [carregar, setCarregar] = useState(false);
    var [data, setData]   = useState([]);
    var consultaDefault  = ConsultaGrupoProduto.consulta + " WHERE SBM.D_E_L_E_T_ <> '*' AND BM_MSBLQL != '1' ";

    useEffect(() => {
        loadGrupoProduto();
    }, []);

    // Processa consulta do grid
    const loadGrupoProduto = async () => {
        setCarregar(true);
        var retConsulta = await ConsultaTotvsEmpresa( consultaDefault, ConsultaGrupoProduto.tabelas )
        setData(retConsulta.data);
        setCarregar(false);
    }

    const handleAlterar = (row) =>{
        navigate(`./Alterar/${row.values.BM_GRUPO.trim()}/${row.original.EMPRESA}${row.original.M0_CODFIL.trim()}`)
    }

    return (
        <>
        <Row>
            <LoadingSpinner isLoading={carregar}/>
            <Col md="12" xs="12">
                <TitlePage 
                    text="Grupo de Produto"
                    exibirIncluir={false}
                />
            </Col>
            <Col md="3" xs="12">
                <Form.Group as={Col} className="md-2" controlId="formGridBuscar">
                    <InputGroup size="md" className="mb-3">
                        <Button variant="outline-primary" type="submit" onClick={loadGrupoProduto}>
                            Buscar
                        </Button>
                    </InputGroup>
                </Form.Group>
            </Col>
        </Row>
        
        <Row>
            { data.length > 0 &&
                <Col md="12" xs="12">
                    <ResponsiveDataTable 
                        columns={columns} 
                        data={data} 
                        buttons= {[
                            {isAlterar: true, action: handleAlterar, label: "Alterar", icone: "MdOutlineEditNote"}
                        ]}
                    />
                </Col>
            }
        </Row>
        </>
    );
}

export default ListaGrupoProduto;